import React from 'react';
import { Col, Icon, Row } from '@mc/ui-v4';
import { mcFilterRange } from '@mc/react-ui-icons';
import classNames from 'classnames';
export const ValueRange = ({ firstValue, secondValue, arrowClassName = 'pb-1', iconSize }) => {
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: "auto" }, firstValue),
        React.createElement(Col, { className: classNames('d-flex px-0', arrowClassName), xs: "auto" },
            React.createElement(Icon, { className: "my-auto", size: iconSize, icon: mcFilterRange, intent: "secondary" })),
        React.createElement(Col, null, secondValue)));
};
//# sourceMappingURL=ValueRange.js.map